export const state = {
  connectionId: null,
  dashboard: {
    statistics: {
      location: {
        location_name: 'Loading...',
        description: 'Loading...',
        distance: 'Calculating'
      }
    },
  },
  incident: {
    statistics: {},
    analysis: {},
    incidents: [],
    vsdsIncidents: [],
    vidsIncidents: [],
  },
  accident: {
    statistics: {},
    accidents: []
  },
  atcc: {
    statistics: {},
    data: [],
    allRecords: []
  },
  challans: {
    statistics: {},
    data: []
  },
};

export const getters = {
  connectionId: (state) => state.connectionId,
  dashboard: (state) => state.dashboard,
  incident: (state) => state.incident,
  accident: (state) => state.accident,
  atcc: (state) => state.atcc,
  challans: (state) => state.challans,
};

export const mutations = {
  SOCKET_CONNECTION_ID (state, id) {
    state.connectionId = id;
  },
  SOCKET_DASHBOARD_STATISTICS (state, data) {
    state.dashboard.statistics = data;
  },
  SOCKET_INCIDENT_ANALYSIS (state, data) {
    state.incident.analysis = data;
  },
  SOCKET_INCIDENT_STATISTICS (state, data) {
    state.incident.statistics = data;
  },
  SOCKET_INCIDENT_DATA (state, data) {
    state.incident.incidents = data;
  },
  SOCKET_ACCIDENT_DATA (state, data) {
    state.accident.accidents = data;
  },
  SOCKET_VSDS_DATA (state, data) {
    state.incident.vsdsIncidents = data;
  },
  SOCKET_VIDS_INCIDENTS (state, data) {
    state.incident.vidsIncidents = data;
  },
  SOCKET_VIDS_INCIDENTS_STATS (state, data) {
    state.incident.statistics = { ...state.incident.statistics, vids: data };
  },
  SOCKET_VSDS_INCIDENTS_STATS (state, data) {
    state.incident.statistics = { ...state.incident.statistics, vsds: data };
  },
  SOCKET_ACCIDENT_STATISTICS (state, data) {
    state.accident.statistics = data;
  },
  SOCKET_ATCC_STATISTICS (state, data) {
    state.atcc.statistics = data;
  },
  SOCKET_CHALLAN_STATISTICS (state, data) {
    state.challans.statistics = data;
  },
  SOCKET_CHALLAN_RECORDS (state, data) {
    state.challans.data = data;
  },
  ATCC_TRAFFIC_DATA (state, data) {
    state.atcc.data = data;
  },
  ATCC_TRAFFIC_ALL_RECORDS (state, data) {
    state.atcc.allRecords = data;
  },
};

export const actions = {
  async SOCKET_CONNECTION_ID ({ commit }, id) {
    commit("SOCKET_CONNECTION_ID", id);
  },
  async SOCKET_DASHBOARD_STATISTICS ({ commit }, data) {
    commit("SOCKET_DASHBOARD_STATISTICS", data);
  },
  async SOCKET_INCIDENT_STATISTICS ({ commit }, data) {
    commit("SOCKET_INCIDENT_STATISTICS", data);
  },
  async SOCKET_INCIDENT_ANALYSIS ({ commit }, data) {
    commit("SOCKET_INCIDENT_ANALYSIS", data);
  },
  async SOCKET_ACCIDENT_STATISTICS ({ commit }, data) {
    commit("SOCKET_ACCIDENT_STATISTICS", data);
  },
  async SOCKET_INCIDENT_DATA ({ commit }, data) {
    commit("SOCKET_INCIDENT_DATA", data);
  },
  async SOCKET_ACCIDENT_DATA ({ commit }, data) {
    commit("SOCKET_ACCIDENT_DATA", data);
  },
  async SOCKET_VSDS_DATA ({ commit }, data) {
    commit("SOCKET_VSDS_DATA", data);
  },
  async SOCKET_VIDS_INCIDENTS ({ commit }, data) {
    commit("SOCKET_VIDS_INCIDENTS", data);
  },
  async SOCKET_VIDS_INCIDENTS_STATS ({ commit }, data) {
    commit("SOCKET_VIDS_INCIDENTS_STATS", data);
  },
  async SOCKET_VSDS_INCIDENTS_STATS ({ commit }, data) {
    commit("SOCKET_VSDS_INCIDENTS_STATS", data);
  },
  async SOCKET_ATCC_STATISTICS ({ commit }, data) {
    commit("SOCKET_ATCC_STATISTICS", data);
  },
  async SOCKET_CHALLAN_STATISTICS ({ commit }, data) {
    commit("SOCKET_CHALLAN_STATISTICS", data);
  },
  async SOCKET_CHALLAN_RECORDS ({ commit }, data) {
    commit("SOCKET_CHALLAN_RECORDS", data);
  },
  async SOCKET_ATCC_TRAFFIC_DATA ({ commit }, data) {
    commit("ATCC_TRAFFIC_DATA", data);
  },
  async SOCKET_ATCC_TRAFFIC_ALL_RECORDS ({ commit }, data) {
    commit("ATCC_TRAFFIC_ALL_RECORDS", data);
  },
};
